import React, { useState } from "react";
import { v1 as uuid } from "uuid";
import styled, { createGlobalStyle } from "styled-components";

// 🔥 Global reset (fixes white edges)
const GlobalStyle = createGlobalStyle`
  html, body, #root {
    margin: 0;
    padding: 0;
    height: 100%;
    width: 100%;
    overflow: hidden;
  }
`;

const Container = styled.div`
  height: 100vh;
  width: 100vw;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
`;

const Card = styled.div`
  background: rgba(255, 255, 255, 0.95);
  padding: 40px;
  border-radius: 20px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  text-align: center;
  max-width: 400px;
  width: 100%;
  backdrop-filter: blur(10px);
`;

const Title = styled.h1`
  color: #2d3748;
  margin-bottom: 30px;
  font-size: 2rem;
  font-weight: 600;
`;

const Input = styled.input`
  width: 100%;
  padding: 15px 20px;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  font-size: 16px;
  transition: all 0.3s ease;
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: #667eea;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
  }
`;

const Button = styled.button`
  width: 100%;
  padding: 15px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 20px;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 20px rgba(102, 126, 234, 0.3);
  }

  &:active {
    transform: translateY(0);
  }
`;

const CreateRoom = (props) => {
  const [name, setName] = useState("");

  const create = () => {
    if (!name.trim()) {
      alert("Please enter your name");
      return;
    }
    localStorage.setItem("username", name);
    const id = uuid();
    props.history.push(`/room/${id}`);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      create();
    }
  };

  return (
    <>
      <GlobalStyle />
      <Container>
        <Card>
          <Title>Create Video Room</Title>
          <Input
            type="text"
            placeholder="Enter your name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            onKeyPress={handleKeyPress}
          />
          <Button onClick={create}>Create Room</Button>
        </Card>
      </Container>
    </>
  );
};

export default CreateRoom;
